// Erorile din browser in Sentry, doar daca aplicatia are un DSN (VITE_SENTRY_DSN la build).
// SDK-ul se incarca separat (import dinamic), deci fara DSN nu costa nimic in pagina. Fara date
// personale: fara IP, fara cookie-uri, fara replay; doar eroarea, pagina si versiunea.
export function initMonitoring(opts: {
  dsn: string | undefined;
  app: string;
  release?: string;
}): void {
  if (!opts.dsn) return;
  void import('@sentry/browser')
    .then((Sentry) => {
      Sentry.init({
        dsn: opts.dsn,
        release: opts.release,
        environment: location.hostname === 'localhost' ? 'local' : 'production',
        tracesSampleRate: 0,
        initialScope: { tags: { app: opts.app } },
      });
    })
    .catch(() => undefined);
}
